import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import authService from "../../services/authService";
import api from "../../services/api";

const savedToken = localStorage.getItem("token");
const savedUser = localStorage.getItem("user");

export const login = createAsyncThunk(
  "auth/login",
  async ({ email, password }, thunkAPI) => {
    try {
      const payload = await authService.login(email, password);
      return payload;
    } catch (err) {
      const msg = err?.response?.data?.message || "Login failed";
      return thunkAPI.rejectWithValue(msg);
    }
  }
);

export const getProfile = createAsyncThunk(
  "auth/getProfile",
  async (_, thunkAPI) => {
    try {
      const user = await authService.getProfile();
      return user;
    } catch (err) {
      const msg = err?.response?.data?.message || "Unauthorized";
      return thunkAPI.rejectWithValue(msg);
    }
  }
);
export const register = createAsyncThunk(
  "auth/register",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await authService.register(userData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Registration failed"
      );
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: savedUser ? JSON.parse(savedUser) : null,
    token: savedToken || null,
    isAuthenticated: !!savedToken,
    loading: false,
    error: null,
  },
  reducers: {
    clearError(state) {
      state.error = null;
    },
    logout(state) {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.error = null;
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        const { token, user } = action.payload || {};
        if (token) {
          state.token = token;
          localStorage.setItem("token", token); // interceptor will pick this up
        }
        if (user) {
          state.user = user;
          state.isAuthenticated = true;
          localStorage.setItem("user", JSON.stringify(user));
        } else {
          state.isAuthenticated = !!token;
        }
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Login failed";
      })
      .addCase(getProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.isAuthenticated = true;
        localStorage.setItem("user", JSON.stringify(action.payload));
      })
      .addCase(getProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Unauthorized";
        state.user = null;
        state.isAuthenticated = false;
        localStorage.removeItem("token");
        localStorage.removeItem("user");
      });
  },
});

export const performLogout = () => (dispatch) => {
  // clear axios default Authorization header if present
  try {
    if (
      api &&
      api.defaults &&
      api.defaults.headers &&
      api.defaults.headers.common
    ) {
      delete api.defaults.headers.common["Authorization"];
    }
  } catch (e) {
    // ignore
  }

  localStorage.removeItem("token");
  localStorage.removeItem("user");
  dispatch(logout());
};
export const { clearError, logout } = authSlice.actions;
export default authSlice.reducer;
